<!doctype html>
<html lang="en">
  <head>
    <title>CAS</title>
  </head>
  <body>
    <h1 class="poc-cas">Prueba redireccion CAS - CEIBAL</h1>
  </body>
</html>
